import Swal from 'sweetalert2'

export const toast = (message, type = 'success') => {
  Swal.fire({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 6000,
    icon: type,
    title: message,
  })
}
